import React from 'react';

import moment from 'moment';

import FuzzyVal from './FuzzyVal';

import { shouldShowTrplAsEdited } from '../../../utils';
import TrplSelect from '../../TrplControls/TrplSelect';
import CreateTrplBtn from './CreateTrplBtn';
import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import TrplErrorAlertIcon from './TrplErrorAlertIcon';
import MandatoryAlertIcon from './MandatoryAlertIcon';

import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, TimePicker, DateTimePicker } from '@mui/x-date-pickers';

import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

function DateIconSx() {
  return <EditCalendarOutlinedIcon sx={{ fontSize: "18px", color: '#5D5F77' }} />;
};

export default ({
  rst,
  trpls,
  type,
  groupId,
  classes,
  setTrpl,
  constant,
  isVirtual,
  isNewNode,
  ancestorId,
  tidsChains,
  loadingTids,
  deletedTids,
  hideSetDelete,
  isAnotherNode,
  onRstValueEdit,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  resetDeletedTrplId,
  showMandatoryAlert,
  disableTrplEditing,
  updateDataOnRestoreTrpl,
}) => {
  //const pickerProviderUtils = rst.locale_correction ? MomentUtils : UtcMomentUtils;

  const getTime = (trplValue, myTime) => {
    const now = new Date().getTime();
    const date = moment(trplValue ? +trplValue : now);
    const dateWithCorrection = moment(trplValue ? +trplValue : now).utcOffset(0);

    if (myTime) return date;

    return rst.locale_correction ? date : dateWithCorrection;
  };

  const setDate = (time, trplIndex, tidsChain) => {
    if (time && time.$d && time.$d.getTime()) {
      onRstValueEdit(rst, time.$d.getTime(), trplIndex, ancestorId, tidsChain);
    }
  };

  const format =
    type === 'datetime' ? 'MM/DD/YYYY HH:mm' : type === 'date' ? 'MM/DD/YYYY' : type === 'time' ? 'HH:mm' : '';

  const currentTimezone = rst.locale_correction ? 'system' : 'UTC';
  const disabled = constant || disableTrplEditing;

  return (
    <div className={classes.column}>
      {trpls.map((trpl, trplIndex) => {

        const showMandatoryField = showMandatoryAlert && !trpl.tid;

        const istTplValueCorrect = !trpl.val && trpl.tid ? false : true;
        const trplValue = istTplValueCorrect ? getTime(trpl.val) : null;

        const selectClasses = {
          root: `${classes.itemSelect} ${classes.trplSelectContainer} ${shouldShowTrplAsEdited(trpl)
            ? classes.trplEdited
            : showMandatoryField
              ? classes.mandatoryField
              : isVirtual && disabled
              ? classes.notEditableVirtualTrpl
              : isVirtual
                ? classes.trplVirtual
                : disabled && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                : trpl && trpl.tid
                  ? classes.trplWithValue
                  : classes.trplEmpty
            }`,
        };

        const trplInputProps =
        {
          classes: {
            input: `${classes.trplTextFieldInput} ${shouldShowTrplAsEdited(trpl)
              ? classes.trplEdited
              : showMandatoryField
                ? classes.mandatoryField
                : isVirtual && disabled
                ? classes.notEditableVirtualTrpl
                : isVirtual
                  ? classes.trplVirtual
                  : disabled && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                  : trpl.tid
                    ? classes.trplWithValue
                    : classes.trplEmpty
              }`,
          },
          disableunderline: 'true',
        };

        const defaultTimezone = rst.timezones && rst.timezones.find(zone => zone.default === true);
        const tidsChain = tidsChains && trpl.tid && tidsChains[trpl.tid];

        return (
          <div key={`${rst.title}.${trplIndex}`} className={`${classes.alignCenter} ${trplIndex === 0 ? '' : classes.mt5}`}>
            <div
              title={`My time: ${getTime(trpl.val, true).format(format)}`}
              className={`${classes.fuzzy_parent} ${classes.fw} ${classes.alignCenter} ${classes.relative} ${!trpl.tid && trpl.unsaved ? classes.unsavedNewTrpl : ''}`}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {type === 'datetime' ? (
                  <DateTimePicker
                    ampm={false}
                    disableunderline
                    disabled={disabled}
                    orientation="landscape"
                    timezone={currentTimezone}
                    value={trplValue ? dayjs(Number(trplValue)) : null}
                    components={{ OpenPickerIcon: DateIconSx }}
                    onChange={(time) => {
                      setDate(time, trplIndex, tidsChain)}}
                    slotProps={{
                      textField: { variant: 'outlined', InputProps: trplInputProps },
                    }}
                  />
                ) : type === 'date' ? (
                  <DatePicker
                    disableunderline
                    disabled={disabled}
                    orientation="landscape"
                    timezone={currentTimezone}
                    value={trplValue ? dayjs(Number(trplValue)) : null}
                    components={{ OpenPickerIcon: DateIconSx }}
                    onChange={(time) => setDate(time, trplIndex, tidsChain)}
                    slotProps={{
                      textField: { variant: 'outlined', InputProps: trplInputProps },
                    }}
                  />
                ) : type === 'time' ? (
                  <TimePicker
                    ampm={false}
                    disableunderline
                    disabled={disabled}
                    orientation="landscape"
                    timezone={currentTimezone}
                    value={trplValue ? dayjs(Number(trplValue)) : null}
                    onChange={(time) => setDate(time, trplIndex, tidsChain)}
                    slotProps={{
                      textField: { variant: 'outlined', InputProps: trplInputProps },
                    }}
                  />
                ) : null}
                {trpl.val_fuzzy ?
                  <FuzzyVal
                    top={'-9px'}
                    right={'29px'}
                    classes={classes}
                    value={trpl.val_fuzzy}
                  />
                : null}
              </LocalizationProvider>
            </div>

            {rst.timezones && rst.timezones.length ?
              <div className={`${classes.alignCenter} ${classes.ml5}`}>
                <TrplSelect
                  disabled={constant || disableTrplEditing}
                  margin="none"
                  placeholder={"Time zone"}
                  selectClasses={selectClasses}
                  values={rst.timezones.map(zone => zone.id)}
                  value={trpl.hasOwnProperty("tz") ? trpl.tz : !trpl.tid && defaultTimezone ? defaultTimezone.id : ''}
                  onChange={(e) => {
                    onRstValueEdit(rst, e.target.value, trplIndex, ancestorId, tidsChain, 'tz');
                  }}
                />
              </div>
            : null}

            <TrplErrorAlertIcon trpl={trpl} />
            {showMandatoryField && <MandatoryAlertIcon />}

            {hideSetDelete ? null : trpl.tid ?
              <SetDeleteTrplBtns
                rst={rst}
                type={type}
                trpl={trpl}
                classes={classes}
                groupId={groupId}
                setTrpl={setTrpl}
                trplIndex={trplIndex}
                ancestorId={ancestorId}
                loadingTids={loadingTids}
                isAnotherNode={isAnotherNode}
                setLoadingTids={setLoadingTids}
                removeTrplValue={removeTrplValue}
                setDeletedTrplId={setDeletedTrplId}
                constant={constant || disableTrplEditing}
              />
              :
              <CreateTrplBtn
                rst={rst}
                trpl={trpl}
                classes={classes}
                setTrpl={setTrpl}
                trplIndex={trplIndex}
                isNewNode={isNewNode}
                ancestorId={ancestorId}
                loadingTids={loadingTids}
                deletedTids={deletedTids}
                isAnotherNode={isAnotherNode}
                setLoadingTids={setLoadingTids}
                disableTrplEditing={disableTrplEditing}
                resetDeletedTrplId={resetDeletedTrplId}
                updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              />
            }
          </div>
        );
      }
      )}
    </div>
  );
};
